import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import AuthService from '../../services/AuthService';
import EstudianteService from '../../services/EstudianteService';
import FileUploadService from '../../services/FileUploadService';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)


class EstudianteForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isAdmin: false,
            currentEstudiante:
            {
                id: undefined,
                cedula: '',
                nombre: '',
                apellido: '',
                email: '',
                genero: '',
                fechaNacimiento: new Date(),
                telefono: '',
                celular: '',
                direccion: '',
                cedulaRep: '',
                nombreRep: '',
                jornada: '',
                estado: '',
                institucion: { id: -1 },
                periodoLectivo: '',
                user: undefined,
                observaciones: ''
            },
            editMode: false,
            isDisabled: false,
            message: '',
            successful: false,
            selectInstitucion: [],
            institucionId: '',
            // Estados para la carga de archivos
            selectedFiles: undefined,
            currentFile: undefined,
            progress: 0,
            fileInfos: undefined,
            modalSolicitar: false,
            messageSolicitud: '',
            formErrors: {
                fechaNacimiento: '',
                genero: '',
                direccion: '',
                institucion: '',
                jornada: ''
            },
            isFormValid: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInstitucionChange = this.handleInstitucionChange.bind(this);
        this.handleJornadaChange = this.handleJornadaChange.bind(this);
        this.handleSubmitEstudiante = this.handleSubmitEstudiante.bind(this);
        this.selectFile = this.selectFile.bind(this);
        this.upload = this.upload.bind(this);
        this.handleModalSolicitar = this.handleModalSolicitar.bind(this);
    }

    getEstudianteByUser() {
        EstudianteService.getByUsername(this.state.currentUser.username)
            .then(response => {
                console.log(response.data);
                this.setState({
                    currentEstudiante: {
                        ...response.data,
                        fechaNacimiento: response.data.fechaNacimiento
                            ? moment(response.data.fechaNacimiento, 'YYYY-MM-DD').toDate()
                            : null
                    }
                });
            })
            .catch(e => {
                console.log(e);
            });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        // Validar el género si es el campo que está cambiando
        let generoError = '';
        if (name === 'genero') {
            if (!value) {
                generoError = 'Por favor seleccione un género';
            }
        }

        this.setState(prevState => ({
            currentEstudiante: {
                ...prevState.currentEstudiante,
                [name]: value
            },
            formErrors: {
                ...prevState.formErrors,
                genero: generoError
            },
            isFormValid: !generoError && this.validateForm(prevState, { [name]: value })
        }));
    }

    handleDateChange = (date) => {
        // Validar que la fecha sea válida
        const isValidDate = date && moment(date).isValid();
        let fechaError = '';
        console.log(date);
        if (!isValidDate) {
            fechaError = 'Por favor ingrese una fecha válida';
        } else {
            // Verificar que la fecha no sea futura
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (date > today) {
                fechaError = 'La fecha de nacimiento no puede ser futura';
            } else {
                // Verificar que la fecha no sea menor a 10 años desde la fecha actual
                const tenYearsAgo = moment().subtract(10, 'years').toDate();
                tenYearsAgo.setHours(0, 0, 0, 0);

                if (date > tenYearsAgo) {
                    fechaError = 'Por favor verificar la fecha de nacimiento ingresada';
                }
            }
        }

        const fechaNacimientoString = date ? moment(date).format('YYYY-MM-DD') : '';

        // Actualizar el estado con la fecha y los errores
        this.setState(prevState => ({
            currentEstudiante: {
                ...prevState.currentEstudiante,
                fechaNacimiento: date // Guardamos el objeto Date completo
            },
            formErrors: {
                ...prevState.formErrors,
                fechaNacimiento: fechaError
            },
            isFormValid: !fechaError && this.validateForm(prevState, { fechaNacimiento: date })
        }));
    }

    // Método auxiliar para validar el formulario
    validateForm = (state, updates = {}) => {
        const { currentEstudiante } = state;
        const updatedEstudiante = { ...currentEstudiante, ...updates };

        // Validar que todos los campos requeridos estén completos
        const requiredFields = ['nombre', 'apellido', 'genero', 'fechaNacimiento', 'institucion'];
        const hasAllRequiredFields = requiredFields.every(field => {
            if (field === 'institucion') {
                return updatedEstudiante[field]?.id > 0;
            }
            return !!updatedEstudiante[field];
        });

        // Aquí puedes agregar más validaciones si es necesario

        return hasAllRequiredFields && !this.state.formErrors.fechaNacimiento;
    }

    handleInstitucionChange = (selectedOption) => {
        const institucionId = selectedOption ? selectedOption.value : null;
        const error = !institucionId ? 'Por favor seleccione una institución' : '';

        this.setState(prevState => ({
            currentEstudiante: {
                ...prevState.currentEstudiante,
                institucion: {
                    ...prevState.currentEstudiante.institucion,
                    id: institucionId || -1
                }
            },
            formErrors: {
                ...prevState.formErrors,
                institucion: error
            }
        }), () => {
            // Validar el formulario completo después de actualizar el estado
            this.validateFormOnSubmit();
        });
    }

    handleJornadaChange(selectedOption) {
        const jornadaValue = selectedOption ? selectedOption.value : null;
        const error = !jornadaValue ? 'Por favor seleccione una jornada' : '';

        this.setState(prevState => ({
            currentEstudiante: {
                ...prevState.currentEstudiante,
                jornada: jornadaValue
            },
            formErrors: {
                ...prevState.formErrors,
                jornada: error
            },
            isFormValid: !error && this.validateForm(
                { currentEstudiante: { ...prevState.currentEstudiante, jornada: jornadaValue } }
            )
        }));
    }

    async getOptions() {
        const res = await EstudianteService.getInstituciones();
        const data = res.data

        const options = data.map(d => ({
            "value": d.id,
            "label": d.nombre
        }))
        this.setState({ selectInstitucion: options })
    }

    checkEstadoEstudiante() {
        if (this.state.currentEstudiante.id) {
            if (this.state.currentEstudiante.estado === "REGISTRADO" || this.state.currentEstudiante.estado === "DEVUELTO") {
                this.setState({
                    editMode: true,
                    isDisabled: false
                });
            }
            else {
                this.setState({
                    editMode: false,
                    isDisabled: true
                });
            }
        } else {
            this.setState({
                editMode: false,
                isDisabled: false,
            });
        }
    }

    // Método para obtener información del archivo subido
    getFileInfo() {
        if (!this.state.currentEstudiante || !this.state.currentEstudiante.id) return;

        FileUploadService.getFileByEstudiante(this.state.currentEstudiante.id)
            .then(response => {
                this.setState({
                    fileInfos: response.data
                });
            })
            .catch(error => {
                console.log('No se encontró archivo subido:', error);
                this.setState({ fileInfos: undefined });
            });
    }

    // Manejar selección de archivo
    selectFile(event) {
        const myFile = event.target.files[0];
        if (myFile) {
            if (!myFile.name.endsWith('.pdf')) {
                this.setState({
                    message: "Por favor seleccione un archivo PDF válido",
                    successful: false,
                    selectedFiles: undefined // Limpiar archivo en caso de cambio
                });
            }
            else if (myFile.size > 5 * 1024 * 1024) { //Validar tamaño del archivo 5MB
                this.setState({
                    message: "El archivo no puede exceder los 5MB.",
                    successful: false,
                    selectedFiles: undefined // Limpiar archivo en caso de cambio
                });
            }
            else {
                this.setState({
                    selectedFiles: event.target.files,
                    message: ""
                });
            }
        }
    }

    // Subir archivo al servidor
    upload(estudianteId) {
        const { selectedFiles } = this.state;
        if (!selectedFiles) return Promise.resolve();

        const currentFile = selectedFiles[0];
        const estudianteIdToUse = estudianteId || this.state.currentEstudiante?.id;

        if (!estudianteIdToUse) {
            console.error("No se pudo obtener el ID del estudiante para la carga del archivo");
            return Promise.reject("No se pudo obtener el ID del estudiante");
        }

        this.setState({
            progress: 0,
            currentFile: currentFile,
            message: ""
        });

        return new Promise((resolve, reject) => {
            FileUploadService.upload(
                currentFile,
                (event) => {
                    this.setState({
                        progress: Math.round((100 * event.loaded) / event.total)
                    });
                },
                estudianteIdToUse
            )
                .then((response) => {
                    this.setState({
                        message: response.data.message,
                        successful: true,
                        fileInfos: {
                            name: currentFile.name,
                            url: response.data.fileUrl || "#"
                        }
                    });
                    resolve(response);
                })
                .catch((error) => {
                    console.error("Error al subir archivo:", error);
                    const errorMessage = error.response?.data?.message ||
                        "No se pudo subir el archivo. Asegúrese de que el tamaño no exceda 5MB.";

                    this.setState({
                        progress: 0,
                        message: errorMessage,
                        currentFile: undefined,
                        successful: false
                    });
                    reject(new Error(errorMessage));
                });
        });
    }

    handleModalSolicitar() {
        this.setState(prevState => ({
            modalSolicitar: !prevState.modalSolicitar
        }));
    }

    validateFormOnSubmit() {
        const { currentEstudiante } = this.state;
        const errors = {};

        // Validar institución
        if (!currentEstudiante.institucion || currentEstudiante.institucion.id <= 0) {
            errors.institucion = 'Por favor seleccione una institución';
        }

        // Validar género
        if (!currentEstudiante.genero) {
            errors.genero = 'Por favor seleccione un género';
        }

        // Validar dirección
        if (!currentEstudiante.direccion || !currentEstudiante.direccion.trim()) {
            errors.direccion = 'La dirección es obligatoria';
        }

        // Validar jornada  
        if (!currentEstudiante.jornada) {
            errors.jornada = 'Por favor seleccione una jornada';
        }

        // Validar fecha de nacimiento
        if (!currentEstudiante.fechaNacimiento) {
            errors.fechaNacimiento = 'Por favor ingrese una fecha de nacimiento';
        } else {
            const hoy = moment().startOf('day');
            const fechaNac = moment(currentEstudiante.fechaNacimiento).startOf('day');
            if (fechaNac.isAfter(hoy)) {
                errors.fechaNacimiento = 'La fecha de nacimiento no puede ser mayor a la fecha actual.';
            } else {
                const minFecha = moment().subtract(10, 'years').startOf('day'); //Verificar que la fecha sea mayor que los últimos 10 años
                if (fechaNac.isAfter(minFecha)) {
                    errors.fechaNacimiento = 'Por favor verificar la fecha de nacimiento ingresada';
                }
            }
        }


        // Validar otros campos requeridos...

        // Actualizar estado de errores
        this.setState(prevState => ({
            formErrors: {
                ...prevState.formErrors,
                ...errors
            },
            isFormValid: Object.keys(errors).length === 0
        }));

        return Object.keys(errors).length === 0;
    }

    async handleSubmitEstudiante(e) {
        e.preventDefault();

        // Obtener fechaNacimiento del estado actual
        const { fechaNacimiento } = this.state.currentEstudiante;

        // Validar que la fecha exista
        if (!fechaNacimiento) {
            this.setState({
                successful: false,
                message: 'Por favor ingrese una fecha de nacimiento.'
            });
            return;
        }

        // Validar formato DD/MM/YYYY
        const fechaString = moment(fechaNacimiento).format('DD/MM/YYYY');
        if (!moment(fechaString, 'DD/MM/YYYY', true).isValid()) {
            this.setState({
                successful: false,
                message: 'La fecha de nacimiento debe tener el formato DD/MM/YYYY.'
            });
            return;
        }

        // Validar que no sea mayor a la fecha actual
        const hoy = moment().startOf('day');
        const fechaNac = moment(fechaNacimiento).startOf('day');
        if (fechaNac.isAfter(hoy)) {
            this.setState({
                successful: false,
                message: 'La fecha de nacimiento no puede ser mayor a la fecha actual.'
            });
            return;
        }

        // Validar que tenga al menos 10 años
        const minFecha = moment().subtract(10, 'years').startOf('day');
        if (fechaNac.isAfter(minFecha)) {
            this.setState({
                successful: false,
                message: 'Por favor verificar la fecha de nacimiento ingresada'
            });
            return;
        }

        // Validar el formulario
        const isValid = this.validateFormOnSubmit();
        if (!isValid) {
            this.setState({
                successful: false,
                message: 'Por favor complete correctamente todos los campos requeridos.'
            });
            return;
        }

        // Formatear la fecha como dd/mm/yyyy para el envío
        // const formattedDate = fechaNacimiento ? moment(fechaNacimiento).format('DD/MM/YYYY') : '';

        // Crear el objeto estudiante con la fecha formateada
        // const estudianteToSave = {
        //     ...this.state.currentEstudiante,
        //     fechaNacimiento: formattedDate
        // };

        // Verificar si es una actualización y no se ha seleccionado un archivo nuevo
        if (this.state.editMode && !this.state.selectedFiles && !this.state.fileInfos) {
            this.setState({
                successful: false,
                message: "Debe subir un archivo con los documentos requeridos para actualizar el perfil."
            });
            return;
        }

        // Para nuevos registros, se requiere un archivo
        if (!this.state.editMode && !this.state.selectedFiles) {
            this.setState({
                successful: false,
                message: "Debe seleccionar el archivo con los documentos requeridos para continuar."
            });
            return;
        }

        //Validar tamaño del archivo
        if (this.state.selectedFiles && this.state.selectedFiles.size > 5 * 1024 * 1024) {
            this.setState({
                successful: false,
                message: "El archivo no puede exceder los 5MB."
            });
            return;
        }

        try {
            // 1. Primero guardar/actualizar el estudiante
            const estudianteActualizado = {
                ...this.state.currentEstudiante,
                // Corregimos el formato de la fecha para evitar desfase por zona horaria
                fechaNacimiento: moment(this.state.currentEstudiante.fechaNacimiento).format('YYYY-MM-DD'),
                // Si el estado actual es 'DEVUELTO' o es un nuevo registro, lo marcamos como 'SOLICITADO'
                estado: (this.state.editMode && this.state.currentEstudiante.estado !== 'DEVUELTO')
                    ? this.state.currentEstudiante.estado
                    : "SOLICITADO"
            };

            let response;
            if (this.state.editMode) {
                // Si es edición, actualizamos el estudiante existente
                response = await EstudianteService.updateEstudiante(
                    this.state.currentEstudiante.id,
                    estudianteActualizado
                );

                // Si hay un archivo seleccionado, lo subimos
                if (this.state.selectedFiles) {
                    await this.upload(response.data.id);
                    this.setState({
                        message: "Estudiante actualizado y archivo subido exitosamente"
                    });
                } else {
                    this.setState({
                        message: "Estudiante actualizado exitosamente"
                    });
                }

                // Actualizamos el estado con la respuesta
                this.setState({
                    currentEstudiante: response.data,
                    editMode: true,
                    successful: true
                });
            } else {
                // Si es nuevo registro, primero guardamos el estudiante
                response = await EstudianteService.saveEstudiante(estudianteActualizado);

                // Subir el archivo con el ID del nuevo estudiante
                await this.upload(response.data.id);

                // Actualizamos el estado con el estudiante recién creado
                await this.setState({
                    currentEstudiante: response.data,
                    editMode: true,
                    successful: true,
                    message: "Estudiante registrado y archivo subido exitosamente"
                });

                // Luego subimos el archivo con el ID del estudiante recién creado
                if (response.data && response.data.id) {
                    await this.upload(response.data.id);
                } else {
                    throw new Error("No se pudo obtener el ID del estudiante después de guardar");
                }

                // Cargar información del archivo
                this.getFileInfo();
            }

            // Actualizar el estado final
            const isNew = !this.state.editMode;
            this.setState(prevState => ({
                message: isNew
                    ? "¡Se ha registrado correctamente!"
                    : "¡Se ha actualizado correctamente!",
                successful: true,
                isDisabled: true,
                currentEstudiante: {
                    ...response.data,
                    fechaNacimiento: response.data.fechaNacimiento
                        ? moment(response.data.fechaNacimiento, 'YYYY-MM-DD').format('YYYY-MM-DD')
                        : '',
                    institucion: response.data.institucion || prevState.currentEstudiante?.institucion,
                    // Mantener el estado actual o usar "SOLICITADO" si no hay estado
                    estado: response.data.estado || "SOLICITADO"
                }
            }), () => {
                // Redirigir después de actualizar el estado
                setTimeout(() => {
                    this.props.history.push('/profile');
                }, 3000);
            });
        } catch (error) {
            console.error("Error en el proceso:", error);
            const resMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();

            this.setState({
                successful: false,
                message: resMessage || "Ocurrió un error al procesar la solicitud"
            });
        }
    }

    componentDidMount() {
        //Obtener info del usuario actual
        const user = AuthService.getCurrentUser();
        if (user) {
            this.setState({
                currentUser: user,
                isAdmin: user.roles.includes("ROLE_ADMIN"),
            });
        }

        //Obtener Estudiante
        EstudianteService.getByUsername(user.username)
            .then(response => {
                console.log(response.data);
                this.setState({
                    currentEstudiante: {
                        ...response.data,
                        fechaNacimiento: response.data.fechaNacimiento
                            ? moment(response.data.fechaNacimiento, 'YYYY-MM-DD').toDate()
                            : null
                    }
                });

                if (this.state.currentEstudiante)
                    this.checkEstadoEstudiante();
            })
            .catch(e => {
                console.log(e);
                let newEstudiante = {
                    cedula: this.state.currentUser.username,//username=cedula
                    nombre: this.state.currentUser.nombre,
                    apellido: this.state.currentUser.apellido,
                    email: this.state.currentUser.email,
                    estado: "REGISTRADO",
                    periodoLectivo: { id: 6 },//TODO: como setear periodo
                    user: { id: this.state.currentUser.id }
                };

                this.setState(prevState => ({
                    currentEstudiante: {
                        ...prevState.currentEstudiante,
                        cedula: newEstudiante.cedula,
                        nombre: newEstudiante.nombre,
                        apellido: newEstudiante.apellido,
                        email: newEstudiante.email,
                        estado: newEstudiante.estado,
                        periodoLectivo: newEstudiante.periodoLectivo,
                        user: newEstudiante.user
                    }
                }));

            });

        this.getOptions();
        // Cargar archivo si ya existe
        if (this.state.currentEstudiante && this.state.currentEstudiante.id) {
            this.getFileInfo();
        }
    }

    render() {
        const {
            currentEstudiante, editMode, isDisabled, message, successful
        } = this.state;
        const btnTitleSaveUpdate = editMode ? 'Actualizar' : 'Guardar';

        const jornadaOptions = [
            { value: 'Matutina', label: 'Matutina' },
            { value: 'Vespertina', label: 'Vespertina' },
            { value: 'Nocturna', label: 'Nocturna' }
        ]

        return (
            <div className="page-bg">
                <div className="container">
                    <div className="row">
                        <div className="card col-md-10 offset-md-1 offset-md-1">
                            <h3 className=" card-header bg-light text-center">Registrar Estudiante</h3>
                            <div className="card-body">
                                <form onSubmit={this.handleSubmitEstudiante}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="cedula">Cédula:</label>
                                                <input placeholder="Cédula de identidad" name="cedula" className="form-control"
                                                    value={currentEstudiante.cedula} onChange={this.handleInputChange} disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="email">Email:</label>
                                                <input placeholder="Correo electrónico" name="email" className="form-control"
                                                    value={currentEstudiante.email} onChange={this.handleInputChange} disabled />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="nombre">Nombres:</label>
                                                <input placeholder="Nombres" name="nombre" className="form-control"
                                                    value={currentEstudiante.nombre} onChange={this.handleInputChange} disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="apellido">Apellidos:</label>
                                                <input placeholder="Apellidos" name="apellido" className="form-control"
                                                    value={currentEstudiante.apellido} onChange={this.handleInputChange} disabled />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Género:</label>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="genero" id="Masculino" value="Masculino" checked={currentEstudiante.genero === "Masculino"} onChange={this.handleInputChange} disabled={isDisabled} />
                                                    <label className="form-check-label" htmlFor="Masculino">
                                                        Masculino
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="genero" id="Femenino" value="Femenino" checked={currentEstudiante.genero === "Femenino"} onChange={this.handleInputChange} disabled={isDisabled} />
                                                    <label className="form-check-label" htmlFor="Femenino">
                                                        Femenino
                                                    </label>
                                                </div>
                                                {this.state.formErrors.genero && (
                                                    <div className="invalid-feedback d-block">
                                                        {this.state.formErrors.genero}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="fechaNacimiento">Fecha de Nacimiento:</label>
                                                <DatePicker
                                                    selected={currentEstudiante.fechaNacimiento ? moment(currentEstudiante.fechaNacimiento, 'YYYY-MM-DD').toDate() : null} onChange={this.handleDateChange}
                                                    className="form-control"
                                                    locale="es"
                                                    dateFormat="dd/MM/yyyy"
                                                    disabled={isDisabled}
                                                />
                                                {this.state.formErrors.fechaNacimiento && (
                                                    <div className="invalid-feedback d-block">
                                                        {this.state.formErrors.fechaNacimiento}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="telefono">Teléfono:</label>
                                                <input type="text" placeholder="Teléfono convencional" name="telefono" className="form-control"
                                                    value={currentEstudiante.telefono} onChange={this.handleInputChange} disabled={isDisabled} maxLength="10" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="celular">Celular:</label>
                                                <input type="text" placeholder="Número de celular" name="celular" className="form-control"
                                                    value={currentEstudiante.celular} onChange={this.handleInputChange} disabled={isDisabled} maxLength="10" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="direccion">Dirección:</label>
                                                <input
                                                    type="text"
                                                    placeholder="Dirección de domicilio"
                                                    name="direccion"
                                                    className="form-control"
                                                    value={currentEstudiante.direccion || ''}
                                                    onChange={this.handleInputChange}
                                                    disabled={isDisabled}
                                                />
                                                {this.state.formErrors.direccion && (
                                                    <div className="invalid-feedback d-block">
                                                        {this.state.formErrors.direccion}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="cedulaRep">Cédula del Representante:</label>
                                                <input type="text" placeholder="Cédula del representante" name="cedulaRep" className="form-control"
                                                    value={currentEstudiante.cedulaRep} onChange={this.handleInputChange} disabled={isDisabled} maxLength="10" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="nombreRep">Nombre del Representante:</label>
                                                <input type="text" placeholder="Nombre completo del representante" name="nombreRep" className="form-control"
                                                    value={currentEstudiante.nombreRep} onChange={this.handleInputChange} disabled={isDisabled} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Institución:</label>
                                                <Select
                                                    options={this.state.selectInstitucion || []}
                                                    placeholder="Seleccione una institución"
                                                    isDisabled={isDisabled}
                                                    value={this.state.selectInstitucion?.filter(option =>
                                                        option && option.value === this.state.currentEstudiante?.institucion?.id
                                                    )}
                                                    onChange={this.handleInstitucionChange}
                                                />
                                                {this.state.formErrors.institucion && (
                                                    <div className="invalid-feedback d-block">
                                                        {this.state.formErrors.institucion}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Jornada:</label>
                                                <Select
                                                    options={jornadaOptions}
                                                    placeholder="Seleccione una jornada"
                                                    isDisabled={isDisabled}
                                                    value={jornadaOptions.filter(option => option.value === this.state.currentEstudiante.jornada)}
                                                    onChange={this.handleJornadaChange}
                                                />
                                                {this.state.formErrors.jornada && (
                                                    <div className="invalid-feedback d-block">
                                                        {this.state.formErrors.jornada}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* Sección de carga de archivos */}
                                    <div className="row">
                                        <div className="col-12 mt-n4">
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0">Documentos Requeridos</h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="alert alert-info">
                                                        <strong>Nota:</strong> Adjunte el acta de grado notariada, copia de cédula y certificado de votación del estudiante y representante legal, además de una copia de planilla de servicios básicos, todo en un único archivo PDF (Tamaño máximo de 5MB).
                                                    </div>

                                                    {this.state.currentFile && (
                                                        <div className="progress mb-3">
                                                            <div
                                                                className="progress-bar progress-bar-striped"
                                                                role="progressbar"
                                                                style={{ width: `${this.state.progress}%` }}
                                                                aria-valuenow={this.state.progress}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            >
                                                                {this.state.progress}%
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="mb-3">
                                                        <label htmlFor="inputFile" className="form-label">Documentos Requeridos (PDF, máximo 5MB)</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            id="inputFile"
                                                            accept=".pdf"
                                                            onChange={this.selectFile}
                                                            disabled={isDisabled}

                                                        />
                                                    </div>

                                                    {this.state.fileInfos && (
                                                        <div className="mt-3">
                                                            <p className="mb-2"><strong>Archivo subido:</strong></p>
                                                            <a
                                                                href={this.state.fileInfos.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-sm btn-outline-primary"
                                                            >
                                                                {this.state.fileInfos.name}
                                                            </a>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        {!isDisabled && (
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={this.state.currentFile && this.state.progress > 0 && this.state.progress < 100}
                                            >
                                                {this.state.currentFile && this.state.progress > 0 && this.state.progress < 100 ? (
                                                    <span>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Procesando...
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <i className="fas fa-save me-2"></i>
                                                        {btnTitleSaveUpdate}
                                                    </span>
                                                )}
                                            </button>
                                        )}
                                        {currentEstudiante.estado === "SOLICITADO" && (
                                            <div className="alert alert-success mb-0 py-2">
                                                <i className="fas fa-check-circle me-2"></i>
                                                Solicitud enviada correctamente
                                            </div>
                                        )}
                                    </div>
                                    {message && (
                                        <div className="form-group pt-2">
                                            <div
                                                className={
                                                    successful
                                                        ? "alert alert-success"
                                                        : "alert alert-danger"
                                                }
                                                role="alert"
                                            >
                                                {message}
                                            </div>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }



}

export default withRouter(EstudianteForm)
